export default __webpack_public_path__ + "static/white-crystal-5512c6a524caf154ec00280577dd8e87.png";